import DashboardSection from '@/views/dashboard/DashboardSection.vue';
import DashBoardMain from '@/views/dashboard/tabs/DashBoardMain.vue';

export default [
  {
    path: '/dashboard',
    component: DashboardSection,
    meta: {
      breadcrumb: {
        linkName: 'dashboard.index',
        linkText: 'DashBoard',
      },
    },
    children: [
      {
        path: '',
        component: DashBoardMain,
        name: 'dashboard.index',
      },
    ],
  },
];
